import React from "react";
import { ErrorMessage, useField } from "formik";
import { formErrorMessage } from "./FormErrorMessage"; // Adjust import if needed
import StyledCheckBox from "../StyledComponents/CheckBox/StyledCheckBox";

interface FormikCheckBoxProps {
  name: string;
  label?: string;
  className?: string;
  labelClassName?: string;
  size?: number;
  labelSize?: string;
  color?: string;
  borderColor?: string;
  bgColor?: string;
  checkColor?: string;
  disabled?: boolean;
  isShowError?: boolean;
}

const FormikCheckBox: React.FC<FormikCheckBoxProps> = ({
  name,
  label,
  className,
  labelClassName,
  size,
  labelSize,
  color,
  borderColor,
  bgColor,
  checkColor,
  disabled,
  isShowError = true,
}) => {
  const [field, meta, helpers] = useField<boolean>(name);
  const { value } = field;
  const { setValue } = helpers;

  const hasError = meta.touched && meta.error;

  return (
    <div className="d-flex flex-column">
      <StyledCheckBox
        value={!!value}
        onChange={(e: any) => setValue(e.target.checked)}
        label={label}
        disabled={disabled}
        className={className}
        labelClassName={labelClassName}
        size={size}
        labelSize={labelSize}
        color={color}
        borderColor={borderColor}
        bgColor={bgColor}
        checkColor={checkColor}
      />

      {isShowError && hasError && (
        <ErrorMessage name={name} render={formErrorMessage} />
      )}
    </div>
  );
};

export default FormikCheckBox;
